// extracted by mini-css-extract-plugin
module.exports = {"personnelList":"Personnels_personnelList_2ZM6V","detail":"Personnels_detail_2D3uO"};